<template>
 <card padding="0" class="flex justify-center items-center w-full bg-cover bg-repeat-round" @click="click" :style="{ height, backgroundImage: `url('${this.thumb}')` }">
   <b-icon icon="play-circle-outline" size="is-large" class="text-white"></b-icon>
   <!-- <img :src="thumb" class="VideoCard-img w-full" :height="height" /> -->
  </card>
</template>

<script>
import Card from './Card'
export default {
  components: {
    Card
  },
  props: {
    thumb: String,
    video: String
  },
  computed: {
    height () {
      return this.isSm ? '180px' : '240px'
    }
  },
  methods: {
    click () {
      if (this.video) window.open(this.video, '_blank')
    }
  }
}
</script>

<style scoped>
  .VideoCard-img {
    border-radius: inherit;
  }
</style>
